import React from 'react';
import PropTypes from 'prop-types';
import AppInput from '../../common/AppInput';
import AppSelect from '../../common/AppSelect';
import { Typography } from '@material-ui/core';
import {
  CONTENT_TITLE,
  REVIEW_FRECUENT_QUESTIONS,
} from '../../../constants/texts';
import { useProvidersStyles } from './styles';
import { optionMapper } from '../../../helpers/ProvidersHelper';

const Form = ({ ...props }) => {
  const { state, onData, fields } = props;
  const classes = useProvidersStyles();

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  return (
    <React.Fragment>
      <Typography className={classes.title}>{CONTENT_TITLE}</Typography>
      <Typography className={classes.subtitle}>
        {REVIEW_FRECUENT_QUESTIONS}
      </Typography>

      {fields.map((field, index) => (
        <React.Fragment key={index}>
          {field.inputType !== 'select' && (
            <AppInput
              onChange={handleChange}
              onBlur={() => {}}
              onClick={() => {}}
              disabled={state[field.name]?.disabled || false}
              name={field.name}
              error={state[field.name]?.error || false}
              type={state[field.name]?.type || ''}
              label={state[field.name]?.label || ''}
              required={state[field.name]?.required || false}
              inputAdornment={state[field.name]?.inputAdornment || ''}
              success={state[field.name]?.success || ''}
              helperText={state[field.name]?.helper || ''}
              multiline={state[field.name]?.multiline || false}
              rows={state[field.name]?.rows || ''}
              value={state[field.name]?.value || ''}
              errorMessage={state[field.name]?.message || ''}
            />
          )}
          {field.inputType === 'select' && (
            <AppSelect
              label={state[field.name]?.label || ''}
              name={field.name}
              options={optionMapper.get(field.name)}
              onChange={handleChange}
              required={state[field.name]?.required || false}
              onClick={() => {}}
              onBlur={() => {}}
            />
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  fields: PropTypes.array,
};

export default Form;
